import React from "react";
import {Route , Redirect} from "react-router-dom";

import { useSelector } from "react-redux";
const ProtectedRoute =({user , children , ...rest}) =>{
    const localToken= localStorage.getItem("profile");
  const token = useSelector((state)=>state?.user?.user?.token);
  // console.log(localToken)
  // console.log(token)
 
  return(<Route {...rest} 
render={({location})=>(token===localToken&&token&&localToken)?(children):(<Redirect to={{pathname:"/login",state:{from:location}}}></Redirect>)

}
></Route>)}
export default ProtectedRoute;